var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _c("div", { staticClass: "card-body" }, [
            _vm.loading
              ? _c("div", { staticClass: "text-center" }, [_vm._m(1)])
              : _c("div", [
                  _c("div", { staticClass: "section" }, [
                    _c("h3", [_vm._v("Add New Setting")]),
                    _c(
                      "form",
                      {
                        staticClass: "row",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.addSetting($event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "newSettingKey" } }, [
                              _vm._v("Setting Key")
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newSetting.key,
                                  expression: "newSetting.key"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "newSettingKey",
                                placeholder: "e.g., max_pickls_per_user",
                                required: ""
                              },
                              domProps: { value: _vm.newSetting.key },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newSetting,
                                    "key",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "newSettingLabel" } }, [
                              _vm._v("Label")
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newSetting.label,
                                  expression: "newSetting.label"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "newSettingLabel",
                                placeholder: "e.g., Maximum Pickls Per User",
                                required: ""
                              },
                              domProps: { value: _vm.newSetting.label },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newSetting,
                                    "label",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "newSettingValue" } }, [
                              _vm._v("Value")
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newSetting.value,
                                  expression: "newSetting.value"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "newSettingValue",
                                placeholder: "e.g., 10",
                                required: ""
                              },
                              domProps: { value: _vm.newSetting.value },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newSetting,
                                    "value",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v(" ")]),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-block",
                                attrs: {
                                  type: "submit",
                                  disabled: _vm.addingSetting
                                }
                              },
                              [
                                _vm.addingSetting
                                  ? _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-sm mr-2",
                                      attrs: { role: "status" }
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.addingSetting
                                        ? "Adding..."
                                        : "Add Setting"
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "section" }, [
                    _c("h3", [_vm._v("Current Settings")]),
                    _vm.settings.length === 0
                      ? _c("div", { staticClass: "text-center" }, [
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v("No settings found for this brand.")
                          ])
                        ])
                      : _c("div", { staticClass: "table-responsive" }, [
                          _c("table", { staticClass: "table table-striped" }, [
                            _vm._m(2),
                            _c(
                              "tbody",
                              _vm._l(_vm.settings, function(setting) {
                                return _c("tr", { key: setting.id }, [
                                  _c("td", [
                                    !setting.editing
                                      ? _c("span", [
                                          _vm._v(_vm._s(setting.key))
                                        ])
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: setting.editKey,
                                              expression: "setting.editKey"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text", required: "" },
                                          domProps: { value: setting.editKey },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                setting,
                                                "editKey",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                  ]),
                                  _c("td", [
                                    !setting.editing
                                      ? _c("span", [
                                          _vm._v(_vm._s(setting.label))
                                        ])
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: setting.editLabel,
                                              expression: "setting.editLabel"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text", required: "" },
                                          domProps: {
                                            value: setting.editLabel
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                setting,
                                                "editLabel",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                  ]),
                                  _c("td", [
                                    !setting.editing
                                      ? _c("span", [
                                          _vm._v(_vm._s(setting.value))
                                        ])
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: setting.editValue,
                                              expression: "setting.editValue"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text", required: "" },
                                          domProps: {
                                            value: setting.editValue
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                setting,
                                                "editValue",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                  ]),
                                  _c("td", [
                                    !setting.editing
                                      ? _c("div", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-outline-primary mr-2",
                                              on: {
                                                click: function($event) {
                                                  return _vm.startEdit(setting)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            Edit\n                          "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-outline-danger",
                                              attrs: {
                                                disabled:
                                                  _vm.deletingSetting ===
                                                  setting.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteSetting(
                                                    setting.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm.deletingSetting === setting.id
                                                ? _c("span", {
                                                    staticClass:
                                                      "spinner-border spinner-border-sm mr-1",
                                                    attrs: { role: "status" }
                                                  })
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                            Delete\n                          "
                                              )
                                            ]
                                          )
                                        ])
                                      : _c("div", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-success mr-2",
                                              attrs: {
                                                disabled:
                                                  _vm.updatingSetting ===
                                                  setting.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.saveEdit(setting)
                                                }
                                              }
                                            },
                                            [
                                              _vm.updatingSetting === setting.id
                                                ? _c("span", {
                                                    staticClass:
                                                      "spinner-border spinner-border-sm mr-1",
                                                    attrs: { role: "status" }
                                                  })
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                            Save\n                          "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-secondary",
                                              on: {
                                                click: function($event) {
                                                  return _vm.cancelEdit(setting)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            Cancel\n                          "
                                              )
                                            ]
                                          )
                                        ])
                                  ])
                                ])
                              }),
                              0
                            )
                          ])
                        ])
                  ])
                ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h1", [_vm._v("Brand Settings")]),
      _c("p", [_vm._v("Manage brand-specific settings with key-value pairs")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Key")]),
        _c("th", [_vm._v("Label")]),
        _c("th", [_vm._v("Value")]),
        _c("th", [_vm._v("Actions")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }